// @ts-nocheck
import { t } from '../../services/i18n';

/**
 * StreamCombos - Gère la création, le chargement et la sauvegarde des combos de streams
 */
export class StreamCombos {
    constructor() {
        this.comboModal = document.getElementById('combo-modal');
        this.createComboModal = document.getElementById('create-combo-modal');
        this.manageCombosBtn = document.getElementById('manage-combos-btn');
        
        // Stocker les combos de l'utilisateur
        this.userCombos = this.loadCombosFromStorage();

        // Disponible pour les menus de la sidebar dès l'initialisation des événements.
        window.streamCombos = this;
        
        // Initialiser les événements
        this.initEvents();
        window.addEventListener('interface-language-change', () => {
            const saveButton = document.getElementById('save-combo-btn');
            const modalTitle = document.querySelector('#create-combo-modal .modal-header h2');
            const isEditing = saveButton?.dataset.mode === 'edit';
            if (saveButton) saveButton.textContent = t(isEditing ? 'combos.update' : 'combos.save');
            if (modalTitle) modalTitle.textContent = t(isEditing ? 'combos.edit' : 'combos.create');
            this.loadUserCombos();
            if (this.featuredCombos) {
                this.renderFeaturedCombos(document.getElementById('featured-combos-list'), this.featuredCombos);
            }
        });
        
    }
    
    /**
     * Initialise les événements
     */
    initEvents() {
        // Bouton pour ouvrir le modal des combos
        this.manageCombosBtn.addEventListener('click', () => this.openComboModal());
        
        // Gestion des onglets dans le modal
        this.comboModal.addEventListener('click', (event) => {
            const tab = event.target.closest('.tab[data-tab]');
            if (tab) {
                this.switchTab(tab.dataset.tab);
                return;
            }

            const loadButton = event.target.closest('.load-combo-btn[data-combo-id]');
            if (loadButton) {
                event.preventDefault();
                this.loadCombo(loadButton.dataset.comboId);
                return;
            }

            const editButton = event.target.closest('.edit-combo-btn[data-combo-id]');
            if (editButton) {
                event.preventDefault();
                this.openCreateComboModal(editButton.dataset.comboId);
                return;
            }

            const deleteButton = event.target.closest('.delete-combo-btn[data-combo-id]');
            if (deleteButton) {
                event.preventDefault();
                this.deleteCombo(deleteButton.dataset.comboId);
            }
        });
        
        // Boutons pour fermer les modals
        document.querySelectorAll('.close-modal').forEach(closeBtn => {
            closeBtn.addEventListener('click', (e) => {
                const modal = e.target.closest('.modal');
                this.closeModal(modal);
            });
        });
        
        // Clic en dehors du contenu pour fermer le modal
        window.addEventListener('click', (e) => {
            if (e.target.classList.contains('modal')) {
                this.closeModal(e.target);
            }
        });
        
        // Bouton pour créer un nouveau combo
        document.getElementById('create-combo-btn').addEventListener('click', () => {
            this.openCreateComboModal();
        });
        
        // Ajouter un streamer au combo en cours de création
        document.getElementById('add-streamer-to-combo').addEventListener('click', () => {
            this.addStreamerInputToCombo();
        });
        
        // Sauvegarder un nouveau combo
        document.getElementById('save-combo-btn').addEventListener('click', () => {
            this.saveNewCombo();
        });
        
        // Export/Import
        document.getElementById('export-combos-btn').addEventListener('click', () => {
            this.exportCombos();
        });
        
        document.getElementById('import-combos-btn').addEventListener('click', () => {
            document.getElementById('import-file').click();
        });
        
        document.getElementById('import-file').addEventListener('change', (e) => {
            this.importCombos(e.target.files[0]);
        });
        
        // Filtres pour les combos mis en avant
        document.getElementById('language-filter').addEventListener('change', () => {
            this.filterFeaturedCombos();
        });
        
        document.getElementById('category-filter').addEventListener('change', () => {
            this.filterFeaturedCombos();
        });
        
        // Charger les combos au démarrage
        this.loadUserCombos();
        this.loadFeaturedCombos();
    }
    
    /**
     * Ouvre le modal des combos
     */
    openComboModal() {
        this.comboModal.style.display = 'block';
        this.comboModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden'; // Empêcher le scroll de la page
    }
    
    /**
     * Ouvre le modal de création de combo
     */
    openCreateComboModal(comboId = null, initialStreamers = []) {
        // Créer ou ouvrir la fenêtre modale de création de combo
        const modal = document.getElementById('create-combo-modal');
        if (!modal) return;
        
        modal.style.display = 'block';
        modal.setAttribute('aria-hidden', 'false');
        
        // Si un ID de combo est fourni, c'est une édition
        if (comboId) {
            const combo = this.userCombos.find(c => String(c.id) === String(comboId));
            if (!combo) return;
            
            // Mettre à jour le titre du modal
            const modalTitle = modal.querySelector('.modal-header h2');
            if (modalTitle) {
                modalTitle.textContent = t('combos.edit');
            }
            
            // Remplir le formulaire
            const nameInput = document.getElementById('combo-name');
            const descInput = document.getElementById('combo-description');
            const langSelect = document.getElementById('combo-language');
            const catSelect = document.getElementById('combo-category');
            
            if (nameInput) nameInput.value = combo.name || '';
            if (descInput) descInput.value = combo.description || '';
            if (langSelect) langSelect.value = combo.language || 'en';
            if (catSelect) catSelect.value = combo.category || 'gaming';
            
            // Réinitialiser les champs de streamers
            const streamerInputs = document.querySelector('.streamer-inputs');
            if (streamerInputs) {
                // Garder seulement le premier input
                const firstInput = streamerInputs.querySelector('.streamer-input');
                if (firstInput) {
                    const inputField = firstInput.querySelector('input');
                    if (inputField && combo.streamers.length > 0) {
                        inputField.value = combo.streamers[0];
                    }
                    
                    // Supprimer tous les autres inputs
                    streamerInputs.querySelectorAll('.streamer-input:not(:first-child)').forEach(el => el.remove());
                    
                    // Ajouter les streamers additionnels
                    for (let i = 1; i < combo.streamers.length; i++) {
                        this.addStreamerInputToCombo();
                        const inputs = streamerInputs.querySelectorAll('.streamer-input input');
                        if (inputs[i]) {
                            inputs[i].value = combo.streamers[i];
                        }
                    }
                }
            }

            // Marquer le formulaire comme étant en mode édition
            const saveBtn = document.getElementById('save-combo-btn');
            if (saveBtn) {
                saveBtn.dataset.mode = 'edit';
                saveBtn.dataset.comboId = comboId;
                saveBtn.textContent = t('combos.update');
            }
        } else {
            // Création d'un nouveau combo
            const modalTitle = modal.querySelector('.modal-header h2');
            if (modalTitle) {
                modalTitle.textContent = t('combos.create');
            }
            
            // Réinitialiser le formulaire
            const form = document.getElementById('create-combo-form');
            if (form) form.reset();
            
            // Réinitialiser les champs de streamers
            const streamerInputs = document.querySelector('.streamer-inputs');
            if (streamerInputs) {
                // Garder seulement le premier input et le vider
                const firstInput = streamerInputs.querySelector('.streamer-input');
                if (firstInput) {
                    const inputField = firstInput.querySelector('input');
                    if (inputField) inputField.value = '';
                    
                    // Supprimer tous les autres inputs
                    streamerInputs.querySelectorAll('.streamer-input:not(:first-child)').forEach(el => el.remove());
                }
            }

            const sanitizedStreamers = initialStreamers.map(name => String(name).trim()).filter(Boolean);
            if (streamerInputs && sanitizedStreamers.length > 0) {
                const firstInput = streamerInputs.querySelector('.streamer-input input');
                if (firstInput) firstInput.value = sanitizedStreamers[0];
                for (let i = 1; i < sanitizedStreamers.length; i++) {
                    this.addStreamerInputToCombo();
                    const inputs = streamerInputs.querySelectorAll('.streamer-input input');
                    if (inputs[i]) inputs[i].value = sanitizedStreamers[i];
                }
            }
            
            // Réinitialiser le bouton de sauvegarde
            const saveBtn = document.getElementById('save-combo-btn');
            if (saveBtn) {
                saveBtn.dataset.mode = 'create';
                saveBtn.removeAttribute('data-combo-id');
                saveBtn.textContent = t('combos.save');
            }
        }
        
        // Référencer l'élément de recherche dans la modal
        const searchInput = modal.querySelector('.combo-streamer-search');
        const addButton = modal.querySelector('.combo-add-streamer');
        
        // S'assurer que le champ de recherche est prêt
        if (searchInput) {
            searchInput.focus();
        }
    }
    
    /**
     * Ferme un modal
     */
    closeModal(modal) {
        if (!modal) return;
        modal.style.display = 'none';
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = ''; // Restaurer le scroll
    }
    
    /**
     * Change d'onglet dans le modal
     */
    switchTab(tabName) {
        // Désactiver tous les onglets et panneaux
        document.querySelectorAll('.modal .tab').forEach(tab => {
            tab.classList.remove('active');
            tab.setAttribute('aria-selected', 'false');
        });
        
        document.querySelectorAll('.tab-panel').forEach(panel => {
            panel.classList.remove('active');
        });
        
        // Activer l'onglet et le panneau sélectionnés
        const tab = document.querySelector(`.tab[data-tab="${tabName}"]`);
        const panel = document.getElementById(`${tabName}-panel`);
        tab?.classList.add('active');
        tab?.setAttribute('aria-selected', 'true');
        panel?.classList.add('active');
    }
    
    /**
     * Ajoute un champ d'entrée pour un streamer dans le formulaire de création de combo
     */
    addStreamerInputToCombo() {
        const streamerInputs = document.querySelector('.streamer-inputs');
        const newInput = document.createElement('div');
        newInput.className = 'streamer-input';
        newInput.innerHTML = `
            <input type="text" class="combo-streamer" placeholder="${t('combos.streamerPlaceholder')}">
            <button class="remove-streamer-btn" aria-label="${t('common.remove')}"><i class="fas fa-times"></i></button>
        `;
        
        // Insérer avant le bouton d'ajout
        streamerInputs.insertBefore(newInput, document.getElementById('add-streamer-to-combo'));
        
        // Ajouter l'événement pour supprimer
        this.addRemoveStreamerEvents();
    }
    
    /**
     * Ajoute les événements pour supprimer un streamer du formulaire
     */
    addRemoveStreamerEvents() {
        document.querySelectorAll('.remove-streamer-btn').forEach(btn => {
            // Éviter d'ajouter plusieurs fois le même événement
            btn.removeEventListener('click', this.handleRemoveStreamer);
            btn.addEventListener('click', this.handleRemoveStreamer);
        });
    }
    
    /**
     * Gère la suppression d'un streamer du formulaire
     */
    handleRemoveStreamer(e) {
        const input = e.target.closest('.streamer-input');
        const allInputs = document.querySelectorAll('.streamer-input');
        
        // Ne pas supprimer s'il n'y a qu'un seul input
        if (allInputs.length > 1) {
            input.remove();
        }
    }
    
    /**
     * Sauvegarde un nouveau combo ou met à jour un combo existant
     */
    saveNewCombo() {
        const saveBtn = document.getElementById('save-combo-btn');
        const isEditMode = saveBtn && saveBtn.dataset.mode === 'edit';
        const comboId = isEditMode ? saveBtn.dataset.comboId : null;
        
        const name = document.getElementById('combo-name').value.trim();
        const description = document.getElementById('combo-description').value.trim();
        const language = document.getElementById('combo-language').value;
        const category = document.getElementById('combo-category').value;
        
        // Récupérer tous les noms de streamers
        const streamerInputs = document.querySelectorAll('.combo-streamer');
        const streamers = Array.from(streamerInputs)
            .map(input => input.value.trim())
            .filter(value => value !== '');
        
        // Validation de base
        if (!name) {
            alert(t('combos.nameRequired'));
            return;
        }
        
        if (streamers.length === 0) {
            alert(t('combos.streamerRequired'));
            return;
        }
        
        if (isEditMode) {
            // Mettre à jour un combo existant
            const comboIndex = this.userCombos.findIndex(c => String(c.id) === String(comboId));
            if (comboIndex === -1) return;
            
            const updatedCombo = {
                ...this.userCombos[comboIndex],
                name,
                description,
                language,
                category,
                streamers,
                updated: new Date().toISOString()
            };
            
            this.userCombos[comboIndex] = updatedCombo;
            
            // Sauvegarder dans le localStorage
            this.saveCombosToStorage();
            
            // Mettre à jour l'affichage
            this.loadUserCombos();
            
            // Fermer le modal de création
            this.closeModal(document.getElementById('create-combo-modal'));
            
            // Afficher une notification
            if (window.app && window.app.showNotification) {
                window.app.showNotification(t('combos.updated', { name }), 'success');
            }
        } else {
            // Créer un nouveau combo
            // Générer un ID unique
            const id = 'combo_' + Date.now();
            
            // Créer l'objet combo
            const combo = {
                id,
                name,
                description,
                language,
                category,
                streamers,
                created: new Date().toISOString(),
                isUserCreated: true
            };
            
            // Ajouter à la liste des combos
            this.userCombos.push(combo);
            
            // Sauvegarder dans le localStorage
            this.saveCombosToStorage();
            
            // Mettre à jour l'affichage
            this.loadUserCombos();
            
            // Fermer le modal de création
            this.closeModal(document.getElementById('create-combo-modal'));
            
            // Afficher une notification
            if (window.app && window.app.showNotification) {
                window.app.showNotification(t('combos.created', { name }), 'success');
            }
        }
    }
    
    /**
     * Charge les combos de l'utilisateur
     */
    loadUserCombos() {
        const container = document.getElementById('my-combos-list');
        
        if (this.userCombos.length === 0) {
            container.innerHTML = `
                <div class="empty-state">
                    <i class="fas fa-layer-group"></i>
                    <p>${t('combos.empty')}</p>
                    <p>${t('combos.emptyHint')}</p>
                </div>
            `;
            return;
        }
        
        // Trier par date de création (plus récent en premier)
        const sortedCombos = [...this.userCombos].sort((a, b) => 
            new Date(b.created) - new Date(a.created)
        );
        
        // Générer le HTML
        container.innerHTML = sortedCombos.map(combo => {
            const streamers = Array.isArray(combo.streamers) ? combo.streamers : [];
            const visibleStreamers = streamers.slice(0, 4);
            const remaining = streamers.length - visibleStreamers.length;
            return `
            <div class="combo-item" data-combo-id="${combo.id}">
                <div class="combo-item-header">
                    <span class="combo-item-icon"><i class="fas fa-bookmark"></i></span>
                    <div class="combo-item-copy">
                        <div class="combo-item-name">${this.escapeHtml(combo.name)}</div>
                        <div class="combo-item-description">${this.escapeHtml(combo.description || t('combos.noDescription'))}</div>
                    </div>
                </div>
                <div class="combo-item-meta">
                    <span class="badge language">${this.getLanguageName(combo.language)}</span>
                    <span class="badge category">${this.getCategoryName(combo.category)}</span>
                    <span class="combo-streamer-count"><i class="fas fa-user"></i>${streamers.length}</span>
                </div>
                <div class="combo-item-streamers">
                    ${visibleStreamers.map(streamer => `
                        <span class="combo-streamer-tag">${this.escapeHtml(streamer)}</span>
                    `).join('')}
                    ${remaining > 0 ? `<span class="combo-streamer-tag combo-more-tag">+${remaining}</span>` : ''}
                </div>
                <div class="combo-item-actions">
                    <button class="primary-btn load-combo-btn" data-combo-id="${combo.id}">
                        <i class="fas fa-play"></i><span>${t('combos.load')}</span>
                    </button>
                    <button class="combo-icon-btn edit-combo-btn" data-combo-id="${combo.id}" title="${t('combos.edit')}">
                        <i class="fas fa-pen"></i>
                    </button>
                    <button class="combo-icon-btn danger delete-combo-btn" data-combo-id="${combo.id}" title="${t('common.remove')}">
                        <i class="fas fa-trash"></i>
                    </button>
                </div>
            </div>
        `;
        }).join('');
        this.bindComboButtons(container);
    }
    
    /**
     * Charge les combos mis en avant
     */
    loadFeaturedCombos() {
        const container = document.getElementById('featured-combos-list');
        
        // Exemple de combos mis en avant (à remplacer par des données réelles)
        this.featuredCombos = [
            {
                id: 'zevent2025',
                name: 'ZEvent 2025',
                description: 'ZEVENT, est un projet caritatif destiné à récolter des fonds par le biais du streaming pendant 3 jours.',
                language: 'fr',
                category: 'charitable',
                streamers: ['Alphacast', 'AngleDroit', 'AntoineDaniel', 'AVAMind', 'BagheraJones', 'byilhann', 'chowh1', 'Clemovitch', , 'CrocodyleTV', 'DamDamlive', 'Doigby', 'Domingo', 'DrFeelgood', 'EnjoyPhoenix', 'Etoiles', 'Flamby', 'Gius', 'Gom4rt', 'helydia', 'HortyUnderscore', 'Jirayalecochon', 'JLTomy', 'Joueur_du_Grenier', 'Joyca', 'KennyStream', 'Lapi', 'LittleBigWhale', 'm4fgaming', 'Mastu', 'mistermv', 'MoMaN', 'Mynthos', 'Nicola', 'Ponce', 'Pressea', 'Rivenzi', 'Sakor_', 'samueletienne', 'Shisheyu', 'Sundae', 'SylvainLyve', 'TheGreatReview', 'TheGuill84', 'theodort', 'Ultia', 'zacknani', 'Zerator']
            }
        ];
        
        // Générer le HTML
        this.renderFeaturedCombos(container, this.featuredCombos);
    }
    
    /**
     * Filtre les combos mis en avant
     */
    filterFeaturedCombos() {
        const container = document.getElementById('featured-combos-list');
        const language = document.getElementById('language-filter').value;
        const category = document.getElementById('category-filter').value;
        
        let filteredCombos = [...this.featuredCombos];
        
        // Appliquer le filtre de langue
        if (language !== 'all') {
            filteredCombos = filteredCombos.filter(combo => combo.language === language);
        }
        
        // Appliquer le filtre de catégorie
        if (category !== 'all') {
            filteredCombos = filteredCombos.filter(combo => combo.category === category);
        }
        
        // Afficher les résultats
        this.renderFeaturedCombos(container, filteredCombos);
    }
    
    /**
     * Génère le HTML pour les combos mis en avant
     */
    renderFeaturedCombos(container, combos) {
        if (combos.length === 0) {
            container.innerHTML = `
                <div class="empty-state">
                    <i class="fas fa-filter"></i>
                    <p>${t('combos.noMatch')}</p>
                    <p>${t('combos.noMatchHint')}</p>
                </div>
            `;
            return;
        }
        
        container.innerHTML = combos.map(combo => {
            const streamers = Array.isArray(combo.streamers) ? combo.streamers.filter(Boolean) : [];
            return `
            <div class="combo-item public-combo-item" data-combo-id="${combo.id}">
                <div class="combo-item-header">
                    <span class="combo-item-icon public"><i class="fas fa-compass"></i></span>
                    <div class="combo-item-copy">
                        <div class="combo-item-name">${this.escapeHtml(combo.name)}</div>
                        <div class="combo-item-description">${this.escapeHtml(combo.description || '')}</div>
                    </div>
                </div>
                <div class="combo-item-meta">
                    <span class="badge language">${this.getLanguageName(combo.language)}</span>
                    <span class="badge category">${this.getCategoryName(combo.category)}</span>
                </div>
                <details class="public-combo-streamers">
                    <summary><span><i class="fas fa-users"></i>${t('combos.streamerCount', { count: streamers.length })}</span><i class="fas fa-chevron-down combo-expand-arrow"></i></summary>
                    <div class="combo-item-streamers">${streamers.map(streamer => `<span class="combo-streamer-tag">${this.escapeHtml(streamer)}</span>`).join('')}</div>
                </details>
                <div class="combo-item-actions">
                    <button class="primary-btn load-combo-btn" data-combo-id="${combo.id}">
                        <i class="fas fa-play"></i><span>${t('combos.load')}</span>
                    </button>
                </div>
            </div>
        `;
        }).join('');
        this.bindComboButtons(container);
    }

    bindComboButtons(container) {
        container.querySelectorAll('.load-combo-btn[data-combo-id]').forEach(button => {
            button.onclick = (event) => {
                event.preventDefault();
                event.stopPropagation();
                this.loadCombo(event.currentTarget.dataset.comboId);
            };
        });
        container.querySelectorAll('.edit-combo-btn[data-combo-id]').forEach(button => {
            button.onclick = (event) => {
                event.preventDefault();
                event.stopPropagation();
                this.openCreateComboModal(event.currentTarget.dataset.comboId);
            };
        });
        container.querySelectorAll('.delete-combo-btn[data-combo-id]').forEach(button => {
            button.onclick = (event) => {
                event.preventDefault();
                event.stopPropagation();
                this.deleteCombo(event.currentTarget.dataset.comboId);
            };
        });
    }
    
    /**
     * Charge un combo
     */
    loadCombo(comboId) {
        // Chercher le combo dans les combos utilisateur et mis en avant
        const combo = this.userCombos.find(c => String(c.id) === String(comboId)) ||
                      (this.featuredCombos || []).find(c => String(c.id) === String(comboId));
        
        if (!combo) return;
        
        // Fermer le modal
        this.closeModal(this.comboModal);
        
        // Demander confirmation pour remplacer les streams existants
        let shouldClear = true;
        if (window.app && window.app.streamers.size > 0) {
            shouldClear = confirm(t('combos.clearConfirm'));
            if (shouldClear) {
                // Créer une copie des IDs pour éviter les problèmes lors de la suppression
                const streamerIds = Array.from(window.app.streamers.keys());
                streamerIds.forEach(id => window.app.removeStreamer(id));
            }
        }
        
        // Afficher notification de chargement
        if (window.app && window.app.showNotification) {
            window.app.showNotification(t('combos.loading', { name: combo.name }), 'info');
        }
        
        // Charger tous les streamers en une seule requête via l'API backend
        fetch('/api/streamers/load-multiple', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                usernames: combo.streamers
            })
        })
        .then(response => response.json())
        .then(data => {
            if (!data.success) {
                throw new Error(data.error || 'Error loading streamers');
            }
            
            if (!data.streamers || data.streamers.length === 0) {
                // Si aucun streamer n'est en direct, afficher un message
                // et s'assurer que l'écran d'accueil reste affiché (ou réactivé)
                if (window.app && window.app.showNotification) {
                    window.app.showNotification(data.message || t('combos.none'), 'warning');
                }
                
                // Si l'écran d'accueil existe, s'assurer qu'il est visible
                const welcomeScreen = document.querySelector('.welcome-screen');
                if (welcomeScreen) {
                    welcomeScreen.style.display = 'flex';
                    document.body.classList.add('welcome-screen-active');
                }
                return;
            }
            
            // Des streamers sont disponibles, masquer l'écran d'accueil si nécessaire
            const welcomeScreen = document.querySelector('.welcome-screen');
            if (welcomeScreen) {
                welcomeScreen.style.display = 'none';
                document.body.classList.remove('welcome-screen-active');
            }
            
            // Ajouter tous les streamers à l'application
            if (window.app) {
                // Méthode pour rendre plusieurs streamers d'un coup
                window.app.renderStreamers(data.streamers);
                
                // Mettre à jour l'URL pour refléter les streamers chargés
                setTimeout(() => {
                    window.app.updateUrl();
                }, 500);
                
                // Notification de succès
                if (window.app.showNotification) {
                    window.app.showNotification(
                        t('combos.loaded', { count: data.streamers.length, name: combo.name }),
                        'success'
                    );
                }
            }
        })
        .catch(error => {
            console.error('Error loading combo:', error);
            if (window.app && window.app.showNotification) {
                window.app.showNotification(t('combos.loadError', { message: error.message }), 'error');
            }
        });
    }
    
    /**
     * Supprime un combo
     */
    deleteCombo(comboId) {
        const comboIndex = this.userCombos.findIndex(c => String(c.id) === String(comboId));
        if (comboIndex === -1) return;
        
        // Demander confirmation
        if (confirm(t('combos.deleteConfirm'))) {
            // Supprimer le combo
            const deletedCombo = this.userCombos.splice(comboIndex, 1)[0];
            
            // Sauvegarder dans le localStorage
            this.saveCombosToStorage();
            
            // Mettre à jour l'affichage
            this.loadUserCombos();
            
            // Afficher une notification
            if (window.app && window.app.showNotification) {
                window.app.showNotification(t('combos.deleted', { name: deletedCombo.name }), 'info');
            }
        }
    }
    
    /**
     * Exporte les combos au format JSON
     */
    exportCombos() {
        if (this.userCombos.length === 0) {
            alert(t('combos.noneToExport'));
            return;
        }
        
        // Créer un objet avec les métadonnées
        const exportData = {
            app: 'MultiStream',
            version: '2.0',
            exported: new Date().toISOString(),
            combos: this.userCombos
        };
        
        // Convertir en JSON
        const jsonString = JSON.stringify(exportData, null, 2);
        
        // Créer un Blob et un lien de téléchargement
        const blob = new Blob([jsonString], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = `multistream_combos_${new Date().toISOString().slice(0, 10)}.json`;
        
        // Ajouter à la page, cliquer et supprimer
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        
        // Libérer l'URL
        setTimeout(() => URL.revokeObjectURL(url), 100);
        
        // Afficher une notification
        if (window.app && window.app.showNotification) {
            window.app.showNotification(t('combos.exported'), 'success');
        }
    }
    
    /**
     * Importe les combos depuis un fichier JSON
     */
    importCombos(file) {
        if (!file) return;
        
        const reader = new FileReader();
        const statusElement = document.getElementById('import-status');
        
        reader.onload = (e) => {
            try {
                const importData = JSON.parse(e.target.result);
                
                // Validation de base
                if (!importData.combos || !Array.isArray(importData.combos)) {
                    throw new Error('Invalid combo file format');
                }
                
                // Compter les combos valides
                let validCombos = 0;
                
                // Ajouter chaque combo
                importData.combos.forEach(combo => {
                    // Validation minimale du combo
                    if (!combo.name || !combo.streamers || !Array.isArray(combo.streamers)) {
                        return; // Ignorer ce combo
                    }
                    
                    // Générer un nouvel ID pour éviter les conflits
                    combo.id = 'imported_' + Date.now() + '_' + validCombos;
                    combo.imported = true;
                    combo.isUserCreated = true;
                    combo.created = combo.created || new Date().toISOString();
                    
                    // Ajouter à la liste
                    this.userCombos.push(combo);
                    validCombos++;
                });
                
                // Sauvegarder dans le localStorage
                this.saveCombosToStorage();
                
                // Mettre à jour l'affichage
                this.loadUserCombos();
                
                // Afficher un message de succès
                statusElement.textContent = t('combos.imported', { count: validCombos });
                statusElement.className = 'success';
                
                // Réinitialiser l'input file
                document.getElementById('import-file').value = '';
                
                // Afficher une notification
                if (window.app && window.app.showNotification) {
                    window.app.showNotification(t('combos.imported', { count: validCombos }), 'success');
                }
            } catch (error) {
                console.error('Import error:', error);
                statusElement.textContent = t('common.error', { message: error.message });
                statusElement.className = 'error';
            }
        };
        
        reader.onerror = () => {
            statusElement.textContent = t('combos.readError');
            statusElement.className = 'error';
        };
        
        reader.readAsText(file);
    }
    
    /**
     * Charge les combos depuis le localStorage
     */
    loadCombosFromStorage() {
        const stored = localStorage.getItem('userCombos');
        if (!stored) return [];
        
        try {
            return JSON.parse(stored) || [];
        } catch (error) {
            console.error('Error loading combos from storage:', error);
            return [];
        }
    }
    
    /**
     * Sauvegarde les combos dans le localStorage
     */
    saveCombosToStorage() {
        try {
            localStorage.setItem('userCombos', JSON.stringify(this.userCombos));
            window.dispatchEvent(new CustomEvent('combos-updated'));
        } catch (error) {
            console.error('Error saving combos to storage:', error);
            
            // Afficher une notification d'erreur
            if (window.app && window.app.showNotification) {
                window.app.showNotification(t('combos.storageError'), 'error');
            }
        }
    }
    
    /**
     * Obtient le nom lisible d'un code de langue
     */
    getLanguageName(code) {
        const languages = {
            'en': t('language.en'),
            'fr': t('language.fr'),
            'es': t('language.es'),
            'de': t('language.de'),
            'other': t('filters.other')
        };
        return languages[code] || code;
    }
    
    /**
     * Obtient le nom lisible d'une catégorie
     */
    getCategoryName(code) {
        const categories = {
            'gaming': t('filters.gaming'),
            'esports': t('filters.esports'),
            'talk': t('filters.talk'),
            'music': t('filters.music'),
            'other': t('filters.other'),
            'charitable': t('filters.charitable')
        };
        return categories[code] || code;
    }

    escapeHtml(value) {
        const element = document.createElement('span');
        element.textContent = String(value ?? '');
        return element.innerHTML;
    }
    
    /**
     * Ouvre le modal d'édition pour un combo spécifique
     * @param {string} comboId - L'ID du combo à éditer
     */
    editCombo(comboId) {
        // Trouver le combo à éditer
        const combo = this.userCombos.find(c => c.id === comboId);
        if (!combo) return;
        
        // Ouvrir le modal et préparer l'édition
        this.openComboModal();
        this.switchTab('my-combos');
        
        // Récupérer la référence au formulaire
        const form = document.getElementById('create-combo-form');
        if (!form) return;
        
        // Remplir le formulaire avec les données du combo
        form.querySelector('#combo-name').value = combo.name;
        form.querySelector('#combo-description').value = combo.description || '';
        form.querySelector('#combo-language').value = combo.language || 'en';
        form.querySelector('#combo-category').value = combo.category || 'gaming';
        
        // Supprimer tous les champs de streamer existants sauf un
        const streamerInputs = form.querySelectorAll('.streamer-input');
        for (let i = 1; i < streamerInputs.length; i++) {
            streamerInputs[i].remove();
        }
        
        // Mettre à jour le premier champ de streamer
        if (streamerInputs.length > 0 && combo.streamers.length > 0) {
            streamerInputs[0].querySelector('input').value = combo.streamers[0];
        }
        
        // Ajouter les champs pour les streamers supplémentaires
        for (let i = 1; i < combo.streamers.length; i++) {
            this.addStreamerField(combo.streamers[i]);
        }
        
        // Mettre à jour le formulaire pour indiquer qu'il s'agit d'une édition
        form.dataset.mode = 'edit';
        form.dataset.comboId = comboId;
        
        // Mettre à jour le titre du modal
        const modalTitle = document.querySelector('#create-combo-modal .modal-header h2');
        if (modalTitle) {
            modalTitle.textContent = t('combos.edit');
        }
        
        // Afficher le modal
        document.getElementById('create-combo-modal').style.display = 'block';
    }
}
